var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0V5.4H0.0100002L0 5.409L4 9L0 12.6L0.0100002 12.609H0V18H12V12.609H11.99L12 12.6L8 9L12 5.409L11.99 5.4H12V0H0ZM10 13.05V16.2H2V13.05L6 9.45L10 13.05ZM6 8.55L2 4.95V1.8H10V4.95L6 8.55Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.6fc01c0ac786ca3f6fa0c2bea0f3bbda.svg";
export { ForwardRef as ReactComponent };